<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">นำเข้าข้อมูลพัสดุ</span>
      </v-card-title>
      <v-card-text>
        <div @dragover.prevent @drop.prevent="handleDrop" class="drop-zone">
          <v-file-input
            v-model="selectedFile"
            label="เลือกไฟล์ .xlsx"
            accept=".xlsx"
            show-size
            @change="handleFileChange"
            outlined
            placeholder="ลากไฟล์มาวางหรือคลิกเพื่อเลือก"
          ></v-file-input>
          <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </div>
        <!-- <v-btn @click="downloadTemplate" color="secondary" class="mt-3">
          ดาวน์โหลดไฟล์ Template
        </v-btn> -->
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog" style="width: 130px">ยกเลิก</v-btn>
        <v-btn color="primary" @click="importData" style="width: 130px"
          >นำเข้า</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { saveAs } from 'file-saver';
import useImportExcel from "../../hooks/importExcel.js"
export default {
  emits: ["close", "data-upload"],
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const { validateFileCount, validateFileType, readFileContent} = useImportExcel();
    return {
      validateFileCount,
      validateFileType,
      readFileContent
    }
  },
  data() {
    return {
      validateBlank: "':field' ห้ามเป็นค่าว่าง",
      validateDuplicateInFile: "':field' ห้ามซ้ำกันในไฟล์",
      validateDuplicateInDatabase: "':field' ซ้ำกับในระบบ",
      validateLength : "':field' ระบุความยาวไม่เกิน :length ตัวอักษร",
      validateDataNotFound: "':field' ไม่พบข้อมูล",
      validateDateFormat: "':field' รูปแบบวันที่นำเข้าไม่ถูกต้อง 'DD/MM/YYYY (พ.ศ.)'",
      validateDecimalFormat: "':field' รูปแบบตัวเลขทศนิยมนำเข้าไม่ถูกต้อง '###.##'",
      validateType: "':field' รูปแบบข้อมูลไม่ถูกต้อง",
      validateAddfile: "กรุณาเพิ่มไฟล์",
      validateIncompleteData: "':field' ระบุข้อมูลไม่ครบ",
      validateAddress: "ข้อมูลที่อยู่ไม่สอดคล้องกัน",
      validateImportMaxColumn: "ไม่สามารถนำเข้าข้อมูลได้ เนื่องจำนวนไม่เท่ากับ :maxColumn แถว",
      validateInactive: "':field' ถูกปิดการใช้งาน",      
      validateImportNoData: "เอกสาร : :file ไม่มีข้อมูล",
      validateImportMaxData:"ไม่สามารถนำเข้าข้อมูลได้เกิน :maxData รายการ",
      selectedFile: null,
      errorMessage: "",
      arrayBuffer: null,
      rawDatas: [],
      nt_runno: this.$route.params.nt_runno,
    };
  },
  methods: {
    handleFileChange(file) {
      if (this.isValidFile(file)) {
        this.selectedFile = file;
        this.errorMessage = "";
      } else {
        this.errorMessage = "กรุณาเลือกไฟล์ .xlsx เท่านั้น";
        this.selectedFile = null; // รีเซ็ตไฟล์ที่เลือกหากไฟล์ไม่ถูกต้อง
      }
    },
    handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        const file = files[0];
        if (this.isValidFile(file)) {
          this.selectedFile = file;
          this.errorMessage = "";
        } else {
          this.errorMessage = "กรุณานำเข้าไฟล์ .xlsx เท่านั้น";
        }
      }
    },
    isValidFile(file) {
      return file && file.name.endsWith(".xlsx"); // ตรวจสอบนามสกุลไฟล์
    },
    closeDialog() {
      this.$emit("close", false); // ปิด dialog
      this.selectedFile = null; // รีเซ็ตไฟล์ที่เลือก
      this.errorMessage = ""; // รีเซ็ตข้อความผิดพลาด
    },
    async importData() {
      if (!this.selectedFile) {
        this.errorMessage = "กรุณาเลือกไฟล์ .xlsx";
        return;
      }

      let condition = [
          {
            //บ้านเลขที่*
            name: "address",
            type: "string",
            wordLength: 50,
            isRequire: true,
          },
          // {
          //   //เลขที่ยูนิต*
          //   name: "unit",
          //   type: "string",
          //   wordLength: 50,
          //   isRequire: false,
          // },
          {
            //เลขทะเบียน
            name: "barcode",
            type: "string",
            wordLength: 100,
            isRequire: true,
            isUnique: true,
          },
          {
            //ชื่อ-นามสกุล
            name: "name",
            type: "string",
            wordLength: 100,
            isRequire: true,
          },
          {
            //เบอร์มือถือ
            name: "phone",
            type: "string",
            wordLength: 15,
            isRequire: false,
          },
          {
            //ประเภทพัสดุ
            name: "box",
            type: "string",
            wordLength: 100,
            isRequire: false,
          },
          {
            //ประเภทขนส่ง
            name: "logistic",
            type: "string",
            wordLength: 100,
            isRequire: false,
          },
          // {
          //   //วันที่บันทึกรับพัสดุ
          //   name: "createDate",
          //   type: "date",
          //   isRequire: false,
          // },
        ];

        try {
          const maxRow = 20000;
          // console.log("readFileContent=",this.selectedFile);

          let result = await this.readFileContent(this.selectedFile, 2, maxRow, condition);
          if(!result.success){
            if(result.code == "001"){
              this.errorMessage = this.validateImportNoData.replace(":file", this.selectedFile.name);
            }else if(result.code == "002"){
              this.errorMessage = this.validateImportMaxData.replace(":maxData", maxRow);
            }
            return true;
          }
          this.rawDatas = result.data;
          // console.log("this.rawDatas=", this.rawDatas);
        }
        catch (error) {
          this.errorMessage = error;
          return true;
        }

        await this.validateAndPrepareData();
        this.closeDialog();
    },
    async validateAndPrepareData(){
      await this.getParcelImportByBarcode();
      await this.prepareData();

      // console.log("barcodes=:", this.barcodes);
    },
    async getParcelImportByBarcode(){
        // const barcodes = [...new Set(this.rawDatas.map(item => item['barcode']))];
        let barcodes = "''";
        for (const data of this.rawDatas) {
          barcodes += ",'" + data.barcode + "'";
        }
        let data = {
          nt_runno : this.nt_runno,
          barcodes : barcodes
        };
        // console.log("data=",data);
        await this.$store.dispatch("importParcel/getBarcodes", data);
    },
    async prepareData() {
      let dataResult = [];
      let i = 1;
      for (const data of this.rawDatas) {
        let parcel = data;
        parcel.importStatusCode = "wait";
        parcel.importStatusReason = "";
        parcel.importStatusDescription = "";
        parcel.itemNo = i;
        parcel.markStatus = "";
        parcel.suRunno = "";
        parcel.suCode = "";
        parcel.pd_building = "";
        if(parcel.name){
          parcel.newCus = "false";
        }else{
          parcel.newCus = "true";
        }

        // console.log("parcel=",parcel);
        let unit = this.units.find(e => e.pd_addr == parcel.address);
        if(!unit){ //ไม่พบ address ใน DB
          let messageError = {field: 'address', type: 'doNotExist'};
          parcel.error.push(messageError);
        }
        else {
          parcel.unitId = unit.id;
          parcel.pd_building = unit.pd_building;
          let customer = this.customers(parcel.address, parcel.name);
          // console.log("customer=",customer);
          if(customer){
            parcel.newCus = "false";
            if(data.phone == "" && customer.cs_mobile != ""){
              data.phone = customer.cs_mobile;
            }
          }else{
            parcel.newCus = "true";
          }
        }

        let barcode = this.barcodes.find(e => e.SU_BARCODE == parcel.barcode);
        if(barcode){ //พบ barcode ใน DB
          let messageError = {field: 'barcode', type: 'duplicateInDatabase'};
          parcel.error.push(messageError);
        }

        let box = this.boxTypes.find(e => e.PT_THNAME == parcel.box || e.PT_ENNAME == parcel.box);        
        if(!box){ //ไม่พบ box ใน DB ให้เป็น กล่องเล็ก = 10
          // let messageError = {field: 'box', type: 'doNotExist'};
          // parcel.error.push(messageError);
          parcel.boxId = "10";
        } else {
          parcel.boxId = box.PT_ID;
        }

        let logistic = this.logistics.find(e => e.PL_THNAME == parcel.logistic || e.PL_ENNAME == parcel.logistic);
        if(!logistic){ //ไม่พบ box ใน DB ให้เป็น อื่นๆ = 16
          // let messageError = {field: 'logistic', type: 'doNotExist'};
          // parcel.error.push(messageError);
          parcel.logisticId = "16"
        } else {
          parcel.logisticId = logistic.PL_RUNNO;
        }

        if (data.error.length > 0) {
          parcel.importStatusCode = "invalid";
          parcel.importStatusDescription = data.error[0].field;
          let errorType = data.error[0].type

          switch (data.error[0].type) {
            case "blank":
              errorType = this.validateBlank.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
            case "duplicate":
              errorType = this.validateDuplicateInFile.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
            case "duplicateInDatabase":
              errorType = this.validateDuplicateInDatabase.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
            case "overflow":
              errorType = this.validateLength.replace(":field", this.setFieldLangError(data.error[0].field)).replace(":length", data.error[0].wordLength);
              break;
            case "doNotExist":
              errorType = this.validateDataNotFound.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
            case "invalid":
              errorType = this.validateType.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
            case "invalidDecimal":
              errorType = this.validateDecimalFormat.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
            case "format":
              errorType = this.validateDateFormat.replace(":field", this.setFieldLangError(data.error[0].field));
              break;
          }
          parcel.importStatusReason = errorType;

        }

        dataResult.push(parcel);
        i++;
      }
      // console.log("dataResult=",dataResult);

      await this.$store.dispatch("importParcel/importParcels", dataResult);
      this.$emit("data-upload");
    },
    setFieldLangError(field){
      switch (field) {
        case "address":
          return "บ้านเลขที่";
        case "barcode":
          return "เลขทะเบียน";
        case "name":
          return "ชื่อ-นามสกุล";
        case "phone":
          return "เบอร์มือถือ";
        case "box":
          return "ประเภทพัสดุ";
        case "logistic":
          return "ประเภทขนส่ง";
        case "createDate":
          return "วันที่บันทึกรับพัสดุ";
        default:
          return field;
      }
    },
    async downloadTemplate() {
      // console.log("downloadTemplate:");
      const url = "https://mediacenter.lpn.co.th/files/asset/Parcel/Template/avYpGaqEsrbVYH0Bjb07RfboE0xOn6ayX6cvjCt9.xlsx";
      const fileName = "Parcel_Template.xlsx"; // ชื่อใหม่ที่ต้องการ

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const blob = await response.blob();

        // ใช้ FileSaver.js เพื่อบันทึกไฟล์ด้วยชื่อใหม่
        saveAs(blob, fileName);
      } catch (error) {
        console.error("Download failed:", error);
      }
    },    
    customers(address, name) {
      if (this.units) {
        return this.units.find((e) => e.pd_addr === address && e.cs_fullname === name);
      }
      return null;
    },

  },
  computed: {
    logistics() {
      return this.$store.getters["importParcel/logistics"];
    },
    boxTypes() {
      return this.$store.getters["importParcel/boxTypes"];
    },
    units() {
      return this.$store.getters["importParcel/units"];
    },
    barcodes() {
      return this.$store.getters["importParcel/barcodes"];
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #1976d2;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  margin: 10px 0;
  background-color: #f9f9f9;
  height: 250px;
  padding-top: 90px;
}
.error-message {
  color: red;
  margin-top: 10px;
}
</style>
